import { render, staticRenderFns } from "./VoiceProfileInboundConfig.vue?vue&type=template&id=6dd7fb9e&scoped=true&"
import script from "./VoiceProfileInboundConfig.vue?vue&type=script&lang=js&"
export * from "./VoiceProfileInboundConfig.vue?vue&type=script&lang=js&"
import style0 from "./VoiceProfileInboundConfig.vue?vue&type=style&index=0&id=6dd7fb9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd7fb9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VForm,
  VSelect,
  VTextField,
})
